import { AType, EType, summon } from "@silversea-ssc/functional-support"

export const PriceConfigEnabled = "PriceConfigEnabled" as const
export const PriceConfigEnabledResponse = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral(PriceConfigEnabled),
            url: F.string(),
        },
        "PriceConfigEnabledResponse",
    ),
)
export type CruiseEnabledResponse = AType<typeof PriceConfigEnabledResponse>

export const ECommerceEnabled = "ECommerceEnabled" as const
export const ECommerceEnabledResponse = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral(ECommerceEnabled),
            ecommerceUrl: F.string(),
            priceConfigUrl: F.string(),
        },
        "ECommerceEnabledResponse",
    ),
)
export type ECommerceEnabledResponse = AType<typeof ECommerceEnabledResponse>

export const CruiseNotEnabled = "CruiseNotEnabled" as const
export const CruiseNotEnabledResponse = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral(CruiseNotEnabled),
        },
        "CruiseNotEnabledResponse",
    ),
)
export type CruiseNotEnabledResponse = AType<typeof CruiseNotEnabledResponse>

export const IsEnabledResponse = summon((F) =>
    F.taggedUnion(
        "type",
        {
            PriceConfigEnabled: PriceConfigEnabledResponse(F),
            ECommerceEnabled: ECommerceEnabledResponse(F),
            CruiseNotEnabled: CruiseNotEnabledResponse(F),
        },
        "IsEnabledResponse",
    ),
)

export type IsEnabledResponse = AType<typeof IsEnabledResponse>

export const IsEnabledResponseType = /* @__PURE__ */ summon((F) =>
    F.keysOf({ [PriceConfigEnabled]: null, [ECommerceEnabled]: null, [CruiseNotEnabled]: null }),
)
export type IsEnabledResponseType = AType<typeof IsEnabledResponseType>
export type IsEnabledResponseTypeEncoded = EType<typeof IsEnabledResponseType>

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function THIS_IS_A_COMPILE_TIME_CHECK_DO_NOT_DELETE___ENSURE_IS_ENABLED_RESPONSE_TYPE_CONSISTENCY(
    foo: IsEnabledResponse,
    bar: IsEnabledResponseType,
) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const localFoo: IsEnabledResponse["type"] = bar
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const localBar: IsEnabledResponseType = foo.type
}
